import { CToast, CToastBody, CToaster, CToastHeader } from '@coreui/react-pro'
import React, { useRef } from 'react'

const Toaster = ({ notifications }) => {
  let toasters = useRef({})
  let options = {
    position: 'top-end',
    autohide: true,
    fade: true,
    closeButton: true,
  }
  let toasts = notifications || []
  toasters.current = {
    ...(() => {
      return toasts.reduce((toasters, toast) => {
        toasters[options.position] = toasters[options.position] || []
        toasters[options.position].push({ ...toast, ...options })
        return toasters
      }, {})
    })(),
  }
  return (
    <>
      {Object.keys(toasters.current).map((toasterKey) => (
        <CToaster placement={toasterKey} key={'toaster' + toasterKey}>
          {toasters.current[toasterKey].map((toast, key) => {
            return (
              <CToast
                key={'toast' + key}
                visible={true}
                autohide={toast.autohide}
                color={toast.color}
              >
                <CToastHeader closeButton={toast.closeButton}>
                  <div className="me-auto"> {toast.title || 'Message'}</div>
                </CToastHeader>
                <CToastBody>{toast.message || '-'}</CToastBody>
              </CToast>
            )
          })}
        </CToaster>
      ))}
    </>
  )
}

export default Toaster
